import i18n from '@/lang';
import "core-js/modules/es.object.to-string.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _classCallCheck from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.object.to-string.js";
// src/utils/map/MapLoader.js
import { MAP_CONFIG } from './map.config';
var MapLoader = /*#__PURE__*/function () {
  function MapLoader() {
    _classCallCheck(this, MapLoader);
  }
  _createClass(MapLoader, null, [{
    key: "load",
    value: function load(type) {
      var config = MAP_CONFIG[type];
      if (!config) return Promise.reject(Error(i18n.tc("690")));

      // 检查是否已加载
      var isLoaded = type === 'amap' ? !!window.AMap : !!window.T;
      if (isLoaded) return Promise.resolve();

      // 高德安全密钥特殊处理
      if (type === 'amap' && config.securityJsCode) {
        window._AMapSecurityConfig = {
          securityJsCode: config.securityJsCode
        };
      }

      // didi安全密钥特殊处理
      if (type === 'dmap' && config.securityJsCode) {
        window._DiMapSecurityConfig = {
          securityJsCode: config.securityJsCode
        };
      }
      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        // 根据类型获取对应的 URL 和 Key/TK
        if (type === 'dmap') {
          script.src = config.url(config.version);
        } else {
          script.src = config.url(type === 'amap' ? config.key : config.tk);
        }
        script.onload = function () {
          // 天地图异步初始化检测
          if (type === 'tianditu') {
            var timer = setInterval(function () {
              if (window.T && window.T.Map) {
                clearInterval(timer);
                resolve();
              }
            }, 50);
          } else if (type === 'dmap') {
            window.DiMapLoader.load({
              key: config.key
            }).then(function (_ref) {
              var DiMap = _ref.DiMap;
              window.DMap = DiMap;
              resolve();
            });
          } else {
            resolve();
          }
        };
        script.onerror = function () {
          return reject(new Error("".concat(type, " " + i18n.tc("691"))));
        };
        document.head.appendChild(script);
      });
    }
  }]);
  return MapLoader;
}();
export { MapLoader as default };